<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-button
            type="primary"
            size="small"
            @click="addEquityCard"
            v-if="shopInfo.isMaster"
            >新增权益卡</el-button
          >
          <el-button type="primary" size="small" @click="vipSendCard">会员发卡</el-button>
        </div>
      </div>
      <div class="tab-content">
        <div class="tabs">
          <div
            v-for="(item, index) in tabsList"
            :key="index"
            class="tabs-item"
            :class="{ active: cardType == item.value }"
            @click="change(item.value)"
          >
            {{ item.label }}
          </div>
        </div>
        <div class="card-List" v-if="cardColorArr.length">
          <div class="card-box" v-for="item in cardList" :key="item.shopMemberCardId">
            <div
              class="card-item"
              :style="{
                background: `linear-gradient(to bottom right, ${
                  cardColorObj[item.bg || cardColorArr[0].bg] &&
                  cardColorObj[item.bg || cardColorArr[0].bg].startValue
                }, ${
                  cardColorObj[item.bg || cardColorArr[0].bg] &&
                  cardColorObj[item.bg || cardColorArr[0].bg].endValue
                })`,
              }"
            >
              <img class="card-bg" src="@/assets/img/vip/pattern.png" alt />
              <span
                class="card-name"
                :style="{
                  color: `${
                    cardColorObj[item.bg || cardColorArr[0].bg] &&
                    cardColorObj[item.bg || cardColorArr[0].bg].textColor
                  }`,
                }"
                >{{ item.cardName }}</span
              >
              <span class="price">￥{{ item.price }}</span>
              <span class="discount" v-show="item.cardType == 2">{{ item.times }}次</span>
              <span class="endtime">{{ item.expireDays }}天后</span>
              <span class="sale">已售：{{ item.sold }}</span>
            </div>
            <div class="card-action">
              <el-button type="primary" size="small" @click="addEquityCard(item)"
                >编辑</el-button
              >
              <el-button type="danger" size="small" @click="delEquityCard(item)"
                >删除</el-button
              >
            </div>
          </div>
          <div class="list-none" v-if="!cardList.length">
            <img src="@/assets/img/common/list-none.png" alt />
            <p>暂无数据</p>
            <el-button type="primary" size="small" @click="addEquityCard">新增</el-button>
          </div>
        </div>
        <!-- <div class="no-data" v-if="!cardList.length">请到网付添加会员卡</div> -->
      </div>
    </div>
    <div
      class="popup equity-card"
      :class="{
        show: equityCardPop,
      }"
      style="z-index: 2000"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>{{ equityCardForm.timeCardId ? "编辑" : "增加" }}卡</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="equityCardPop = false"
          />
        </div>
        <div class="popup-container center">
          <el-form
            :model="equityCardForm"
            :rules="equityCardRules"
            ref="equityCardForm"
            label-width="128px"
            :hide-required-asterisk="true"
            status-icon
          >
            <el-form-item label="卡名称" prop="cardName">
              <el-input
                type="text"
                placeholder="请输入卡名称"
                v-model="equityCardForm.cardName"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="售价" prop="price">
              <el-input-number
                v-model="equityCardForm.price"
                :min="1"
                label="请输入售价"
                size="small"
              ></el-input-number>
            </el-form-item>
            <el-form-item
              label="类型"
              prop="templateItem"
              v-if="!equityCardForm.timeCardId"
            >
              <el-radio-group v-model="equityCardForm.cardType" size="small">
                <el-radio-button :label="1">权益卡</el-radio-button>
                <el-radio-button :label="2">次数卡</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="能否余额支付" prop="isBalancePay">
              <el-radio-group v-model="equityCardForm.isBalancePay" size="small">
                <el-radio-button :label="1">是</el-radio-button>
                <el-radio-button :label="0">否</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              class="hav-tips"
              label="次数"
              v-if="equityCardForm.cardType == 2"
            >
              <el-input-number
                v-model="equityCardForm.times"
                :min="1"
                :max="2147483647"
                label="请输入次数"
                size="small"
              ></el-input-number>
              <p class="tips">购买后使用多少次</p>
            </el-form-item>
            <el-form-item label="发卡总数">
              <el-input-number
                v-model="equityCardForm.total"
                :min="1"
                :max="2147483647"
                label="请输入发卡总数"
                size="small"
              ></el-input-number>
            </el-form-item>
            <el-form-item class="hav-tips" label="到期天数">
              <el-input-number
                v-model="equityCardForm.expireDays"
                :min="1"
                :max="2147483647"
                label="请输入到期天数"
                size="small"
              ></el-input-number>
              <p class="tips">购买后开始+设置天数，过期不可用</p>
            </el-form-item>
            <el-form-item label="排序号" prop="sn">
              <el-input-number
                v-model="equityCardForm.sn"
                :min="1"
                :max="2147483647"
                label="请输入排序号"
                size="small"
              ></el-input-number>
            </el-form-item>
            <el-form-item label="使用说明" prop="note">
              <el-input
                type="textarea"
                placeholder="请输入使用说明"
                v-model="equityCardForm.note"
                size="small"
                maxlength="500"
                show-word-limit
              ></el-input>
            </el-form-item>
            <el-form-item class="hav-tips" label="卡片样式" v-if="cardColorArr.length">
              <div
                class="card-item"
                :style="{
                  background: `linear-gradient(to bottom right, ${cardColorArr[cardColorIndex].startValue}, ${cardColorArr[cardColorIndex].endValue})`,
                }"
              >
                <img class="card-bg" src="@/assets/img/vip/pattern.png" alt />
                <span
                  class="card-name"
                  :style="{
                    color: `${cardColorArr[cardColorIndex].textColor}`,
                  }"
                  >{{ equityCardForm.cardName || "卡片名" }}</span
                >
                <span class="price">￥{{ equityCardForm.price }}</span>
                <span class="discount" v-if="equityCardForm.cardType == 2"
                  >{{ equityCardForm.times }}次</span
                >
                <span class="endtime">{{ equityCardForm.expireDays }}天后</span>
                <span class="sale">已售：0</span>
              </div>
              <div class="tips" style="margin: 10px 0">
                <span> 卡片颜色：</span>
                <div class="color-sel">
                  <el-popover
                    placement="right"
                    width="265"
                    trigger="click"
                    v-model="cardColorSelvisible"
                  >
                    <div class="row">
                      <div
                        v-for="(item, index) in cardColorArr"
                        :key="index"
                        class="square"
                        @click="cardColorIndex = index"
                        :style="{ background: item.endValue }"
                      ></div>
                    </div>
                    <div
                      class="color"
                      :style="{
                        background: cardColorArr[cardColorIndex].startValue,
                      }"
                      slot="reference"
                    ></div>
                  </el-popover>
                </div>
              </div>
            </el-form-item>
          </el-form>
          <el-button type="primary" @click="editTimeCard" :loading="isUpload">{{
            equityCardForm.timeCardId ? "编辑" : "增加"
          }}</el-button>
        </div>
      </div>
    </div>
    <div
      class="popup vip-send-card"
      :class="{
        show: vipSendCardPop,
      }"
      style="z-index: 2000"
    >
      <div class="popup-content">
        <div class="popup-header">
          <span>会员发卡</span>
          <img
            class="close"
            src="../assets/img/icon-close-dark.png"
            alt=""
            @click="vipSendCardPop = false"
          />
        </div>
        <div class="popup-container center">
          <el-form
            :model="vipSendCardForm"
            :rules="vipSendCardRules"
            ref="vipSendCardForm"
            label-width="128px"
            :hide-required-asterisk="true"
            status-icon
          >
            <el-form-item label="手机号" prop="phone">
              <el-input
                type="text"
                placeholder="请输入手机号"
                v-model="vipSendCardForm.phone"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="权益卡" prop="timeCardId">
              <el-select
                size="small"
                v-model="vipSendCardForm.timeCardId"
                placeholder="请选择权益卡"
              >
                <el-option
                  v-for="item in totalCardList"
                  :key="item.id"
                  :label="`${item.cardName}--${item.cardType == 1 ? '权益卡' : '次数卡'}`"
                  v-if="item.sold < item.total"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <el-button type="primary" @click="saveTimeMemberCard" :loading="isUpload"
            >确定</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getTimeCardList,
  saveTimeCard,
  memberCardMessage,
  saveTimeMemberCard,
} from "@/api/index.js";
import { mapState } from "vuex";
export default {
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
        // console.log(reg.test(value));
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      totalCardList: [],
      cardList: [],
      cardType: 1,
      tabsList: [
        { value: "1", label: "权益卡" },
        { value: "2", label: "次数卡" },
      ],
      cardColorArr: [],
      cardColorObj: {},
      cardColorIndex: 0,
      cardColorSelvisible: false,
      equityCardPop: false,
      isUpload: false,
      equityCardForm: {
        cardName: "",
        timeCardId: "",
        cardType: 1,
        bg: "",
        expireDays: 1,
        note: "",
        sn: 1,
        times: 1,
        total: 1,
        isDelete: 0,
        price: 0,
        isBalancePay: 0,
      },
      equityCardRules: {
        cardName: [
          {
            required: true,
            message: "请输入权益卡名",
            trigger: "blur",
          },
        ],
        note: [
          {
            required: true,
            message: "请输入使用说明",
            trigger: "blur",
          },
        ],
      },
      vipSendCardPop: false,
      vipSendCardForm: {
        phone: "",
        timeCardId: "",
      },
      vipSendCardRules: {
        phone: [
          {
            validator: checkPhone,
            required: true,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        timeCardId: [
          {
            required: true,
            message: "请选择权益卡",
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    cardColorIndex(val) {
      this.equityCardForm.bg = this.cardColorArr[val].bg;
    },
    equityCardPop(val) {
      if (!val) {
        this.cardColorIndex = 0;
        this.equityCardForm = {
          cardName: "",
          timeCardId: "",
          cardType: this.cardType,
          bg: this.cardColorArr[0].bg,
          expireDays: 1,
          note: "",
          sn: 1,
          times: 1,
          total: 1,
          isDelete: 0,
          price: 0,
          isBalancePay: 0,
        };
      }
    },
    vipSendCardPop(val) {
      if (!val) {
        this.vipSendCardForm = {
          phone: "",
          timeCardId: "",
        };
      }
    },
    cardType(val) {
      this.equityCardForm.cardType = val;
    },
    "equityCardForm.cardType": {
      handler: function (val) {
        if (this.equityCardForm.timeCardId) return;
        this.equityCardForm.isBalancePay = val == 1 ? 0 : 1;
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
      isOwn: (state) => state.isOwn,
    }),
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    getPageData() {
      this.getTimeCardList();
      this.getTotalCardList();
      this.memberCardMessage();
    },
    memberCardMessage() {
      memberCardMessage({
        // shopMemberCardId: 97
      }).then((res) => {
        res.data.shopMemberCardColors.forEach((color) => {
          color.bg = `${color.startValue},${color.endValue},${color.textColor}`;
          this.cardColorObj[
            `${color.startValue},${color.endValue},${color.textColor}`
          ] = color;
        });
        this.cardColorArr = res.data.shopMemberCardColors;
        this.equityCardForm.bg = res.data.shopMemberCardColors[0].bg;
      });
    },
    change(val) {
      this.cardType = val;
      this.getTimeCardList();
    },
    getTimeCardList() {
      getTimeCardList({
        pageSize: 9999,
        cardType: this.cardType,
      }).then((res) => {
        if (res.code == 1) {
          this.cardList = res.data.list;
        }
        if (res.code == -1) {
          this.cardList = [];
        }
      });
    },
    getTotalCardList() {
      this.totalCardList = [];
      getTimeCardList({
        pageSize: 9999,
        cardType: 1,
      }).then((res) => {
        if (res.code == 1) {
          this.totalCardList.push(...res.data.list);
        }
      });
      getTimeCardList({
        pageSize: 9999,
        cardType: 2,
      }).then((res) => {
        if (res.code == 1) {
          this.totalCardList.push(...res.data.list);
        }
      });
    },
    addEquityCard(item = null) {
      if (item.cardName) {
        this.equityCardForm = Object.assign(this.equityCardForm, item);
        if (!this.equityCardForm.bg) {
          this.cardColorIndex = 0;
        } else {
          this.cardColorIndex = this.cardColorArr.findIndex((color) => {
            return (
              this.equityCardForm.bg ==
              `${color.startValue},${color.endValue},${color.textColor}`
            );
          });
        }
        this.equityCardForm.timeCardId = item.id;
      }
      this.equityCardPop = true;
    },
    vipSendCard() {
      this.vipSendCardPop = true;
    },
    delEquityCard(item) {
      this.equityCardForm = Object.assign(this.equityCardForm, item);
      this.equityCardForm.timeCardId = item.id;
      this.equityCardForm.isDelete = 1;
      let params = JSON.parse(JSON.stringify(this.equityCardForm));
      this.saveTimeCard(params);
      this.equityCardForm = {
        cardName: "",
        timeCardId: "",
        cardType: this.cardType,
        bg: this.cardColorArr[0].bg,
        expireDays: 1,
        note: "",
        sn: 1,
        times: 1,
        total: 1,
        isDelete: 0,
        price: 0,
        isBalancePay: 0,
      };
    },
    editTimeCard() {
      this.$refs.equityCardForm.validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.equityCardForm));
          this.saveTimeCard(params);
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    saveTimeMemberCard() {
      this.$refs.vipSendCardForm.validate((valid) => {
        if (valid) {
          this.isUpload = true;
          saveTimeMemberCard({
            phone: this.vipSendCardForm.phone,
            timeCardId: this.vipSendCardForm.timeCardId,
            status: 1,
          }).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: "发卡成功",
                type: "success",
                duration: 1000,
              });
              setTimeout(() => {
                this.getTimeCardList();
                this.getTotalCardList();
              }, 1000);
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 1000,
              });
            }
            this.isUpload = false;
            this.vipSendCardPop = false;
          });
        } else {
          this.$notify({
            title: "提示",
            message: "请完善提交内容",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    saveTimeCard(params) {
      this.isUpload = true;
      saveTimeCard(params).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: params.timeCardId
              ? params.isDelete
                ? "删除成功"
                : "编辑成功"
              : "新增成功",
            type: "success",
            duration: 1000,
          });
          this.getTimeCardList();
          this.getTotalCardList();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 1000,
          });
        }
        this.isUpload = false;
        this.equityCardPop = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.bd {
  height: 100%;
  .tab-content {
    height: calc(100% - 63px);
    padding: 10px 20px 0 20px;
    box-sizing: border-box;
    display: block;
    .tabs {
      display: block;
      .tabs-item {
        display: inline-block;
        width: 50px;
        height: 35px;
        padding: 0 15px;
        border: 1px solid #e4e7ed;
        line-height: 35px;
        text-align: center;
        margin-right: -1px;
        color: #909399;
        font-size: 14px;
        cursor: pointer;
        &.active {
          border-color: #409eff;
          border-bottom: transparent;
          color: #409eff;
          margin-right: 0;
        }
        &:last-child {
          position: relative;
          &::after {
            display: inline-block;
            content: "";
            border-bottom: 1px solid #e4e7ed;
            width: calc(100vw - 450px);
            position: absolute;
            top: 35px;
            left: 81px;
          }
        }
      }
    }
    .card-List {
      width: 100%;
      height: calc(100% - 57px);
      padding: 10px;
      overflow: auto;
      .card-box {
        display: inline-block;
        vertical-align: middle;
        margin-right: 20px;
        margin-bottom: 20px;
        .card-action {
          display: flex;
          justify-content: space-between;
          padding: 10px 50px;
        }
      }
    }
    .no-data {
      text-align: center;
      line-height: 40px;
      font-size: 20px;
    }
  }
}
.card-item {
  width: 297px;
  height: 172px;
  border-radius: 20px;
  position: relative;
  & > span {
    position: absolute;
  }
  button + & {
    margin-top: 20px;
  }
  .card-bg {
    top: 50%;
    position: absolute;
    left: -25%;
    transform: translateY(-50%);
  }
  .card-name {
    font-size: 22px;
    font-weight: bold;
    left: 20px;
    top: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: calc(100% - 40px);
  }
  .price {
    font-size: 22px;
    color: #fff;
    left: 20px;
    top: 54px;
  }
  .discount {
    font-size: 22px;
    color: #fafafa;
    top: 54px;
    right: 20px;
  }
  .endtime {
    font-size: 20px;
    color: #fafafa;
    left: 20px;
    bottom: 20px;
  }
  .sale {
    font-size: 20px;
    color: #fafafa;
    right: 20px;
    bottom: 20px;
  }
}
.popup {
  &.equity-card,
  &.vip-send-card {
    .popup-container {
      width: 500px;
      padding: 20px;
      .el-input {
        width: 220px;
      }
      .hav-tips {
        margin-bottom: 0;
      }
      .tips {
        display: flex;
        line-height: 30px;
        color: #ccc;
      }
      .el-button {
        display: block;
        margin: 0 auto;
      }
    }
    .color-sel {
      height: 30px;
      width: 85px;
      border: 1px solid #bbb;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      .color {
        height: 20px;
        width: 75px;
      }
    }
  }
}
.square {
  height: 17px;
  width: 17px;
  display: inline-block;
  margin-right: 10px;
  cursor: pointer;
}
.list-none {
  text-align: center;
  font-size: 14px;
  color: #999999;
  padding-top: 200px;
  & > p {
    margin: 10px 0;
  }
}
</style>
